











































import Vue from "vue";
import { mapGetters } from "vuex";

//Model
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { AlarmFlagsEnum } from "@/model/data/enums/AlarmFlagsEnum";
import { Configuration } from "@/model/data/security/Configuration";

export default Vue.extend({
    props: {
        configuration: { type: Object as () => Configuration, required: true },
        editMode: Boolean,
        loading: Boolean,
    },
    data() {
        return {
            localConfiguration: null,
            outputAlarms: [
                [
                    { label: this.$t("security_management.alarm1"), value: AlarmFlagsEnum.OverThirdBandWithdrawal, isChecked: false },
                    { label: this.$t("security_management.alarm2"), value: AlarmFlagsEnum.EmptyInAlarmTimeBand, isChecked: false },
                    { label: this.$t("security_management.alarm4"), value: AlarmFlagsEnum.commandCA, isChecked: false },
                    { label: this.$t("security_management.alarm8"), value: AlarmFlagsEnum.DoorOpen, isChecked: false },
                    { label: this.$t("security_management.alarm16"), value: AlarmFlagsEnum.WriteParameters, isChecked: false },
                ],
                [
                    { label: this.$t("security_management.alarm1"), value: AlarmFlagsEnum.OverThirdBandWithdrawal, isChecked: false },
                    { label: this.$t("security_management.alarm2"), value: AlarmFlagsEnum.EmptyInAlarmTimeBand, isChecked: false },
                    { label: this.$t("security_management.alarm4"), value: AlarmFlagsEnum.commandCA, isChecked: false },
                    { label: this.$t("security_management.alarm8"), value: AlarmFlagsEnum.DoorOpen, isChecked: false },
                    { label: this.$t("security_management.alarm16"), value: AlarmFlagsEnum.WriteParameters, isChecked: false },
                ],
                [
                    { label: this.$t("security_management.alarm1"), value: AlarmFlagsEnum.OverThirdBandWithdrawal, isChecked: false },
                    { label: this.$t("security_management.alarm2"), value: AlarmFlagsEnum.EmptyInAlarmTimeBand, isChecked: false },
                    { label: this.$t("security_management.alarm4"), value: AlarmFlagsEnum.commandCA, isChecked: false },
                    { label: this.$t("security_management.alarm8"), value: AlarmFlagsEnum.DoorOpen, isChecked: false },
                    { label: this.$t("security_management.alarm16"), value: AlarmFlagsEnum.WriteParameters, isChecked: false },
                ],
            ],
        };
    },
    watch: {
        configuration: {
            handler(newValue: Configuration) {
                this.resetConfiguration(newValue);
            },
            immediate: true,
        },
        editMode: {
            handler(newVal) {
                if (newVal) this.enterEditMode();
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        canWriteAlarms() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteAlarms);
        },
    },
    methods: {
        enterEditMode() {
            return true;
        },
        saveConfiguration() {
            if (!this.localConfiguration) this.localConfiguration = new Configuration();
            if (!this.localConfiguration.alarms) this.localConfiguration.alarms = new Array<AlarmFlagsEnum>();
            let i = 0;
            for (let outputAlarm of this.outputAlarms) {
                if (this.localConfiguration.alarms[i] == null || this.localConfiguration.alarms[i] == undefined) this.localConfiguration.alarms.push(0);
                this.localConfiguration.alarms[i] = outputAlarm.filter((o) => o.isChecked).reduce((partialSum, a) => partialSum + a.value, 0);
                i += 1;
            }
            return this.localConfiguration;
        },
        resetConfiguration(configuration: Configuration) {
            this.outputAlarms.forEach((outputAlarm) => {
                outputAlarm.forEach((alarm) => {
                    alarm.isChecked = false;
                });
            });
            this.localConfiguration = new Configuration();
            if (configuration) {
                this.localConfiguration.clone(configuration);
                if (this.localConfiguration.alarms && this.localConfiguration.alarms.length) {
                    let i = 0;
                    for (let outputAlarm of this.localConfiguration.alarms) {
                        for (let alarm of this.outputAlarms[i]) {
                            if ((alarm.value & outputAlarm) != AlarmFlagsEnum.None) alarm.isChecked = true;
                        }
                        i += 1;
                    }
                }
            }
        },
    },
});
